angular.module('myApp.directives')
    .directive("deviceSelector", function() {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, userMediaStream, clientTools) {
                var devices     = [];
                var type        = $attrs.deviceSelector;
                var qId         = $attrs.qid || $scope.audioVideoQId;
                var isInited    = false;
                var select      = $("<select></select>");
                select.append($('<option>'+(type == 'video' ? 'Select Camera' : 'Select Microphone')+'</option>'));
                var destroyMenu = function() {
                    if (isInited) {
                        if (clientTools.isMobileLayout()) {
                            select.selectmenu("destroy").off().remove();
                        } else {
                            $element.find("*").off().remove();
                        }
                    }
                };
                var initSelect   = function () {
                    var allDevices = userMediaStream.getDevices();
                    if (allDevices[type].length) {
                        devices             = allDevices[type];
                        destroyMenu();
                        var selectedDevice      = userMediaStream.getCurrentlyPlayingUserMediaDevice(type, qId);
                        var selectedDeviceLabel = null;
                        if (selectedDevice !== null) {
                            selectedDeviceLabel = selectedDevice.label;
                        }
                        for (var i = 0; i < devices.length; i++) {
                            var id = devices[i].id;
                            var opt = select.find('option[value="'+id+'"]');
                            if (opt.length == 0) {
                                var option = $('<option value="' + id + '">' + devices[i].label + '</option>');
                                select.append(option);
                            } else {
                                opt.text(devices[i].label);
                            }
                            if (selectedDeviceLabel === devices[i].label) {
                                select.val(id);
                            }
                        }

                        $element.append(select);
                        var onChangeSelect = function(id) {
                            for (var i = 0; i < devices.length; i++) {
                                if (devices[i].id == id) {
                                    userMediaStream.setUserMediaDevice(type, devices[i]);
                                    $scope.startUserMedia();
                                    break;
                                }
                            }
                        };
                        if (clientTools.isMobileLayout()) {
                            select.selectmenu({
                                nativeMenu: false,
                                create: function() {
                                    isInited = true;
                                }
                            }).on("change", function() {
                                onChangeSelect($(this).val());
                            });
                        } else {
                            Select.init();
                            isInited = true;
                            select.on("change", function () {
                                onChangeSelect($(this).val());
                            });
                        }
                    }
                };
                initSelect();
                $scope.$on("userMediaDevices", function() {
                    initSelect();
                });
                $scope.$on("$destroy", function() {
                    destroyMenu();
                });
            }
        }
    });